import { Box } from "@mui/material";
import CaseDetailHeader from "../modules/caseManagementModule/components/CaseDetailHeader";
import CustomTabs from "../components/CustomTabs";
import { useMemo, useRef, useState } from "react";
import Icons from "../assets/Icons";
import CaseSummary from "../modules/caseManagementModule/components/CaseSummary";
import CaseCodes from "../modules/caseManagementModule/components/CaseCodes";

import { useLocation, useParams } from "react-router";
import getUserRoleAccess, {
  USER_ROLE_ACCESS_KEY,
} from "../helpers/getUserRoleAccess";
import CaseDocumentation from "../modules/caseManagementModule/components/CaseDocumentation";
import { globalStyles } from "../styles/GlobalStyles";

const tabData = [
  { id: "summary", label: "Summary", icon: <Icons.Note /> },
  {
    id: "documentation",
    label: "Documentation",
    icon: <Icons.Documentation />,
  },
  { id: "codes", label: "Codes", icon: <Icons.SearchList /> },
];

const CaseDetail = () => {
  const { caseId } = useParams();
  const { state } = useLocation();
  const { mrn, assignedSurgeon, procedureName } = state?.caseDetail ?? {};

  const isOTManagerAccess = getUserRoleAccess(USER_ROLE_ACCESS_KEY.OT_MANAGER);

  const [activeTab, setActiveTab] = useState<string | number>(
    isOTManagerAccess ? "summary" : "codes"
  );
  const [isEditMode, setIsEditMode] = useState(false);
  const caseSummaryRef = useRef<any>(null);
  const caseCodesRef = useRef<any>(null);

  const handleExport = () => {
    caseSummaryRef?.current?.exportCaseSummaryScreenshot();
  };

  const handleExportCpt = (isCSVExport?: boolean) => {
    if (isCSVExport) {
      caseCodesRef?.current?.exportCaseCodesCsv();
    } else {
      caseCodesRef?.current?.exportCaseCodesScreenshot();
    }
  };

  const { isSummary, isCodes, isDocumentation } = useMemo(() => {
    return {
      isSummary: activeTab === "summary",
      isCodes: activeTab === "codes",
      isDocumentation: activeTab === "documentation",
    };
  }, [activeTab]);

  return (
    <Box sx={globalStyles.colFlex1}>
      <CaseDetailHeader
        mrn={mrn}
        surgeon={assignedSurgeon}
        procedureName={procedureName}
        backToTab={"case_history"} // Always go back to Case History tab
        enableDropDownExport={isCodes}
        onExport={handleExport}
        onExportCpt={handleExportCpt}
        isEditMode={isEditMode}
        onEditModeChange={setIsEditMode}
        caseSummaryRef={caseSummaryRef}
      />
      <CustomTabs
        tabs={isOTManagerAccess ? tabData : tabData.slice(1)}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
      <Box px={2} sx={globalStyles.colFlex1}>
        {isSummary && isOTManagerAccess && (
          <CaseSummary
            caseDetail={state?.caseDetail}
            caseSummaryRef={caseSummaryRef}
            isEditMode={isEditMode}
          />
        )}
        {isCodes && <CaseCodes caseId={caseId} caseCodesRef={caseCodesRef} />}
        {isDocumentation && <CaseDocumentation />}
      </Box>
    </Box>
  );
};

export default CaseDetail;
